import instObj from '@/backend/axios-instances'

const resource = "/account"
const instance = instObj.baseInstance

export default {
  get(id) {
    return instance.get(`${resource}/${id}`);
  }
}
